import WizardStepPage from './WizardStepPage';

/** Step 5 — Departure dates & HSS */
const DeparturesStep = (props) => (
    <WizardStepPage
        stepKey="departures"
        isStepDataLoading={props.isStepDataLoading}
        formData={props.formData?.departures}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        cityOptions={props.cityOptions}
        basePrice={props.formData?.pricing?.base_price ?? props.formData?.packages?.base_price}
        hssTemplates={props.hssTemplates}
        onNewHssTemplate={props.onNewHssTemplate}
        tripCurrency={props.tripCurrency}
    />
);

export default DeparturesStep;
